import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config-service';
import { Partner } from '../../models/partner.model';
import { List } from '../../models/list.model';

@Injectable()
export class PartnerService {
  constructor(private http: HttpClient) { }

  configService = inject(ConfigService);

  public getList
    (params: {
      page: number;
      pageSize: number;
      sort: string;
      sortDirection: string;
      filters?: string[] | undefined;
    }): Observable<List<Partner>> {
    let url = this.configService.readConfig().baseUrlInfrastructure + '/partners';
    let query = '';
    if (params.pageSize) {
      query += `PageSize=${params.pageSize}`;
    }
    if (params.page) {
      query += `&PageNumber=${params.page}`;
    }
    if (params.sort) {
      query += `&Sort=${params.sort}`;
    }
    if (params.sortDirection) {
      query += `&SortDirection=${params.sortDirection}`;
    }
    if (params.filters && params.filters.length > 0) {
      query += `&Filter=${params.filters.join('&Filter=')}`;
    }
    if (query.length > 0) {
      url += '?' + query;
    }
    return this.http.get<List<Partner>>(url);
  }

  public get(id: number): Observable<Partner> {
    let url = this.configService.readConfig().baseUrlInfrastructure + '/partners/partner/' + id;
    return this.http.get<Partner>(url);
  }

  public getPartnerApplications(id: number): Observable<string[]> {
    let url = this.configService.readConfig().baseUrlInfrastructure + '/partners/applications/' + id;
    return this.http.get<string[]>(url);
  }

  public upsert(partner: Partner): Observable<Partner> {
    let url = this.configService.readConfig().baseUrlInfrastructure + '/partners';
    if (partner.id > 0) {
      return this.http.put<Partner>(url, partner);
    }
    else {
      return this.http.post<Partner>(url, partner);
    }
  }

  public delete(id: number): Observable<void> {
    let url = this.configService.readConfig().baseUrlInfrastructure + '/partners/' + id;
    return this.http.delete<void>(url);
  }
}
